module.exports = __webpack_public_path__ + "img/branch-particle-10.2de8bb19.png";